import { render, staticRenderFns } from "./tpl-3.vue?vue&type=template&id=43ff69e0&scoped=true"
import script from "./tpl-3.vue?vue&type=script&lang=js"
export * from "./tpl-3.vue?vue&type=script&lang=js"
import style0 from "./tpl-3.vue?vue&type=style&index=0&id=43ff69e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ff69e0",
  null
  
)

export default component.exports